module.exports = __webpack_public_path__ + "static/clearconcepts-logo-5270f8aee564cd0efec49238f92c5de5.png";